import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { BackButton } from '~/commonComponents';
import {
  LEGACY_SIGNUP_DESIGN_DATE,
  POSTHOG_EVENTS,
  trackPosthogEvent,
  trackPosthogPageView,
} from '~/services/posthog';
import { editUserAccount } from '../../../actions';
import { Colors } from '../../../themes/colors';
import '../../../themes/global.scss';
import '../../../themes/registration.scss';
import { ContainerLayout, ContentLayout, Title } from '../components';
import { DetailedView } from './DetailedView';
import { VerifyPhonePopup } from './VerifyPhonePopup';

export const GeneralOfficeInformation = () => {
  const location = useLocation();
  const isEditing = location?.state?.isEdit || false;
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const [contactNumber, setContactNumber] = useState();

  useEffect(() => {
    trackPosthogPageView('/registration/admin');
  }, []);

  return (
    <>
      <ContainerLayout>
        <div style={{ position: 'absolute', left: 60, top: 140 }}>
          <BackButton color={Colors.white} url="/registration" />
        </div>
        <Title text="General Office Information" progress="step2" />
        <ContentLayout>
          <DetailedView
            isEditing={isEditing}
            submitBtnPressed={(data) => {
              trackPosthogEvent(
                POSTHOG_EVENTS.DENTAL_PORTAL_OFFICE_SIGNUP_GENERAL_OFFICE_INFO_SUBMITTED,
                {
                  form: 'general-office-information',
                  design_date: LEGACY_SIGNUP_DESIGN_DATE,
                },
              );
              dispatch(editUserAccount(data));
              setContactNumber(data.contact_number || user?.contact_number);
            }}
          />
        </ContentLayout>
      </ContainerLayout>
      <VerifyPhonePopup tel={contactNumber} />
    </>
  );
};
